module.exports = __webpack_public_path__ + "img/sieckFinesseSetup7.bc5e9f9e.png";